const routes = {
    home: '/',
    login: '/login',
    forgotPassword: '/forgot-password',
    admin: {
        base: '/admin',
        dashboard: '/dashboard',
        getEditRepair: id => `/admin/repairs/${id}`,
        getEditSale: id => `/admin/sales/${id}`,
        getPartOrderRepair: id => `/admin/partOrder/${id}`,
        getEditBuyback: id => `/admin/buyback/${id}`,
        getInquiry: id => `/admin/inquiries/${id}`,
        buybacksList: '/admin/buyback',
        addRepair: '/repairs/add',
        devices: '/devices',
        dashboardFull: '/admin/dashboard',
        purchaseFull: '/admin/purchase',
        repairsFull: '/admin/repairs',
        inventoryFull: '/admin/inventory',
        devicesFull: '/admin/devices',
        customerFull: '/admin/customer',
        part: {

            base: '/admin/part',

            categories: '/part/categories',
            parts: '/part/items',
            masters: '/part/masters',
            variants: '/part/variants',
            parameters: '/part/parameters',

            categoriesFull: '/admin/part/categories',
            itemsFull: '/admin/part/items',
            mastersFull: '/admin/part/masters',
            variantsFull: '/admin/part/variants',
            parametersFull: '/admin/part/parameters'
        },
        partOrder: {

            base: '/partOrder/items',
            itemsFull: '/admin/partOrder/items',

            editRepair: 'partOrder/:id'
        },
        device: {

            base: '/admin/device',

            categories: '/device/categories',
            items: '/device/items',
            repairCatalog: '/device/repairCatalog',
            diagnosticCatalog: '/device/diagnosticCatalog',
            repairTimes: '/device/repairTimes',

            categoriesFull: '/admin/device/categories',
            itemsFull: '/admin/device/items',
            repairCatalogFull: '/admin/device/repairCatalog',
            diagnosticCatalogFull: '/admin/device/diagnosticCatalog',
            repairTimesFull: '/admin/device/repairTimes',
        },
        buyback: {
            base: '/buyback',
            itemsFull: '/admin/buyback',
            addFull: '/admin/buyback/add',
            add: '/buyback/add',
        },
        sales: {
            base: '/sales',
            itemsFull: '/admin/sales',
            editSale: '/sales/:id'
        },
        partLog: {
            base: '/log/part',
            partLogsFull: '/admin/log/part',
        },
        repairs: {
            base: '/repairs',
            editRepair: 'repairs/:id',
        },
        users: {
            base: '/users',
            itemsFull: '/admin/users',
        },
        customer: {
            base: '/customer',
        },
        inquiries: {
            base: '/inquiries',
            detail: '/inquiries/:id',
            calendar: '/inquiries/calendar',
            settings: '/inquiries/settings',
            full: '/admin/inquiries',
            calendarFull: '/admin/inquiries/calendar',
            settingsFull: '/admin/inquiries/settings'
        },
        settings: {
            base: '/settings',
            full: '/admin/settings',
            emails: '/settings/emails',
            emailsFull: '/admin/settings/emails'
        }
    }
};

export default routes;
